/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@ng-bootstrap/ng-bootstrap/modal/modal-backdrop';
const styles_NgbModalBackdrop:any[] = ([] as any[]);
export const RenderType_NgbModalBackdrop:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_NgbModalBackdrop,data:{}});
export function View_NgbModalBackdrop_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,([] as any[]),(null as any),(null as any));
}
export function View_NgbModalBackdrop_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'ngb-modal-backdrop',
      [['class','modal-backdrop fade show']],(null as any),(null as any),(null as any),
      View_NgbModalBackdrop_0,RenderType_NgbModalBackdrop)),i0.ɵdid(1,49152,(null as any),
      0,i1.NgbModalBackdrop,([] as any[]),(null as any),(null as any))],(null as any),
      (null as any));
}
export const NgbModalBackdropNgFactory:i0.ComponentFactory<i1.NgbModalBackdrop> = i0.ɵccf('ngb-modal-backdrop',
    i1.NgbModalBackdrop,View_NgbModalBackdrop_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9qZW5raW5zX2hvbWUvd29ya3NwYWNlL0NMQUlNU19QSVBFTElORS9DTE1UTEtfVUlfQVBQX1BJUEVMSU5FL25vZGVfbW9kdWxlcy9AbmctYm9vdHN0cmFwL25nLWJvb3RzdHJhcC9tb2RhbC9tb2RhbC1iYWNrZHJvcC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvamVua2luc19ob21lL3dvcmtzcGFjZS9DTEFJTVNfUElQRUxJTkUvQ0xNVExLX1VJX0FQUF9QSVBFTElORS9ub2RlX21vZHVsZXMvQG5nLWJvb3RzdHJhcC9uZy1ib290c3RyYXAvbW9kYWwvbW9kYWwtYmFja2Ryb3AuZC50cyIsIm5nOi8vL3Zhci9qZW5raW5zX2hvbWUvd29ya3NwYWNlL0NMQUlNU19QSVBFTElORS9DTE1UTEtfVUlfQVBQX1BJUEVMSU5FL25vZGVfbW9kdWxlcy9AbmctYm9vdHN0cmFwL25nLWJvb3RzdHJhcC9tb2RhbC9tb2RhbC1iYWNrZHJvcC5kLnRzLk5nYk1vZGFsQmFja2Ryb3BfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bmdiLW1vZGFsLWJhY2tkcm9wPjwvbmdiLW1vZGFsLWJhY2tkcm9wPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7eURBQUEsVUFBQTtNQUFBOzs7OyJ9



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/$$_gendir/node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-backdrop.ngfactory.ts